export default __webpack_public_path__ + "static/media/dq_logo.9747ecba.svg";